import $ from 'jquery';

$(document).on("click", ".toggle-control", function() {
	var control = $(this);
	var target = $(control.attr("data-target"));
	control.toggleClass("open");
	target.toggleClass("open");

	var bodyClass = control.attr('data-body-class');
	if(bodyClass) {
		$("body").toggleClass(bodyClass);
	}
});
